// extracted by css-extract-rspack-plugin
var _1 = "h";
var _2 = "fi";
var _3 = "fx";
var _4 = "fy";
var _5 = "ff";
var _6 = "fh";
export { _1 as "content", _2 as "descriptionText", _3 as "discountLandingPageComponent", _4 as "downloadBanner", _5 as "validity", _6 as "validityText" }
